export default "__VITE_ASSET__DpsE$iO1__"